import { getContainingComponent } from "./helper/utils";

const browserDetect = require("detect-browser");
const NotificationService = require("./services/NotificationService");
const UrlService = require("./services/UrlService");
const AutoFocusService = require("./services/AutoFocusService");

import Vue from "vue";
import { getStyle } from "./helper/dom";
import { detectPassiveEvents } from "./helper/featureDetect";
// import HeaderScroller from "./helper/HeaderScroller";

// Frontend end scripts
// eslint-disable-next-line
const headerCollapses = [];

// function HeaderCollapse(selector)
// {
//     headerCollapses.push(selector);
//     $(document).ready(function()
//     {
//         $(selector).on("show.bs.collapse", () =>
//         {
//             headerCollapses.forEach(element =>
//             {
//                 if (!$(element).is(selector))
//                 {
//                     $(element).collapse("hide");
//                 }
//             });
//         });
//
//     });
// }

function CeresMain()
{
    const browser = browserDetect.detect();

    if (browser)
    {
        if (browser.name)
        {
            $("html").addClass(browser.name);
        }
        else
        {
            $("html").addClass("unknown-browser");
        }
        if (browser.os)
        {
            $("html").addClass(browser.os.toLowerCase().replace(/[^a-zA-Z0-9\-]/g, "-").replace("windows", "windows windows"));
        }
        else
        {
            $("html").addClass("unknown-os");
        }
    }
    else
    {
        $("html").addClass("unknown-detect");
    }

    window.onpopstate = function(event)
    {
        if (event.state && event.state.requireReload)
        {
            window.location.reload();
        }
    };

    // Sorting of FL-Filter elements in the dropdowns
    document.addEventListener("DOMContentLoaded", function()
    {
        if (!document.body.classList.contains("page-category-item") && !document.body.classList.contains("page-search"))
        {
            return;
        }

        const customOrders = [
            ["option-6", "option-8", "option-7"],
            ["option-5", "option-7", "option-6"],
            ["option-1006", "option-1008", "option-1007"]
        ];

        let isSortingInProgress = false;

        let isObserverActive = true;

        // Function to apply CSS order to form-check elements within each filter-dropdown container
        function applyCssOrderToFormChecks()
        {
            if (isSortingInProgress)
            {
                return;
            }

            const filterDropdowns = Array.from(document.querySelectorAll(".filter-dropdown"));

            if (filterDropdowns.length === 0)
            {
                return;
            }

            // Mark sorting as in progress and disable the observer temporarily
            isSortingInProgress = true;
            isObserverActive = false;

            filterDropdowns.forEach(function(dropdown)
            {
                const formChecks = Array.from(dropdown.querySelectorAll(".form-check"));

                if (formChecks.length !== 3)
                {
                    return;
                }

                let matchedOrder = null;

                // Find the matching custom order
                for (const customOrder of customOrders)
                {
                    const ids = formChecks.map(check => check.querySelector("input[id]").id);

                    if (customOrder.every(id => ids.includes(id)))
                    {
                        matchedOrder = customOrder;
                        break;
                    }
                }

                if (matchedOrder)
                {
                    formChecks.forEach(function(check)
                    {
                        const input = check.querySelector("input[id]");

                        const orderIndex = matchedOrder.indexOf(input.id);

                        if (orderIndex !== -1)
                        {
                            check.style.order = orderIndex;
                        }
                        else
                        {
                            check.style.order = "";
                        }

                        if (!matchedOrder.includes(input.id) && check.classList.contains("active"))
                        {
                            check.style.order = -1;
                        }
                    });
                }
            });

            isSortingInProgress = false;

            setTimeout(function()
            {
                isObserverActive = true;
            }, 100);
        }

        // Initialize MutationObserver to watch for changes (new nodes added) anywhere in the document
        const observer = new MutationObserver(function(mutations)
        {
            if (!isObserverActive)
            {
                return;
            }

            mutations.forEach(function(mutation)
            {
                if (mutation.addedNodes.length)
                {
                    let relevantChange = false;

                    Array.from(mutation.addedNodes).forEach(function(node)
                    {
                        if (node.nodeType === 1)
                        {
                            if (node.matches(".filter-dropdown") || node.querySelector(".filter-dropdown"))
                            {
                                relevantChange = true;
                            }
                            else if (node.matches(".form-check"))
                            {
                                if (node.closest(".filter-dropdown"))
                                {
                                    relevantChange = true;
                                }
                            }
                        }
                    });

                    if (relevantChange)
                    {
                        applyCssOrderToFormChecks();
                    }
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });

        // Initial ordering (in case elements are already present)
        setTimeout(applyCssOrderToFormChecks, 1000);
    });

    // init bootstrap tooltips
    document.querySelectorAll("[data-toggle=\"tooltip\"]").forEach(el =>
    {
        $(el).tooltip();
    });
    //
    // HeaderCollapse("#countrySettings");
    // HeaderCollapse("#currencySelect");
    // HeaderCollapse("#searchBox");

    const $mainNavbarCollapse = $("#mainNavbarCollapse");

    // prevent hidding collapses in the shopbuilder, for editing search bar results
    if (!App.isShopBuilder)
    {
        $(document).on("click", function(evt)
        {
            headerCollapses.forEach(element =>
            {
                if (evt.target !== element && $(evt.target).parents(element).length <= 0)
                {
                    $(element).collapse("hide");
                }
            });
        });
    }

    $mainNavbarCollapse.collapse("hide");

    // Add click listener outside the navigation to close it
    $mainNavbarCollapse.on("show.bs.collapse", function()
    {
        $(".main").one("click", closeNav);
    });

    $mainNavbarCollapse.on("hide.bs.collapse", function()
    {
        $(".main").off("click", closeNav);
    });

    function closeNav()
    {
        $("#mainNavbarCollapse").collapse("hide");
    }

    const feedbackObservers = [];

    function cleanFeedbackQuestionMarks()
    {
        // Disconnect all observers before cleaning
        feedbackObservers.forEach(obs => obs.observer.disconnect());

        $(".feedback-list .feedback-comment-text").each(function()
        {
            // Remove sequences of 3 or more question marks
            this.textContent = this.textContent.replace(/\?{3,}/g, "");
        });

        // Reconnect all observers after cleaning
        feedbackObservers.forEach(obs => obs.observer.observe(obs.node, { childList: true, subtree: true }));
    }

    // Attach MutationObserver to all feedback-list elements
    $(".feedback-list").each(function()
    {
        const feedbackListNode = this;
        const observer = new MutationObserver(function(mutationsList)
        {
            for (const mutation of mutationsList)
            {
                // Ignore mutations that only add/remove the loading icon
                let onlyLoadingIcon = true;

                mutation.addedNodes.forEach(node =>
                {
                    if (!(node.nodeType === 1 && node.classList.contains("loadingIcon")))
                    {
                        onlyLoadingIcon = false;
                    }
                });
                mutation.removedNodes.forEach(node =>
                {
                    if (!(node.nodeType === 1 && node.classList.contains("loadingIcon")))
                    {
                        onlyLoadingIcon = false;
                    }
                });
                if (mutation.addedNodes.length && !onlyLoadingIcon)
                {
                    cleanFeedbackQuestionMarks();
                }
            }
        });

        observer.observe(feedbackListNode, { childList: true, subtree: true });
        feedbackObservers.push({ observer, node: feedbackListNode });
    });

    $(document).ready(function()
    {
        // Find the relevant feedback-list (second one, or first non-empty)
        let feedbackList = $("#feedbackContainer .feedback-list").eq(1);

        if (!feedbackList.length || feedbackList.children().length === 0)
        {
            // fallback: use first non-empty feedback-list
            feedbackList = $("#feedbackContainer .feedback-list").filter(function()
            {
                return $(this).children().length > 0;
            }).first();
        }

        cleanFeedbackQuestionMarks();

        $(document).on("click", ".feedback-loadmore", function()
        {
            const feedbackLoadMoreBtn = $(this);

            if (feedbackLoadMoreBtn.find(".loadingIcon").length === 0)
            {
                feedbackLoadMoreBtn.append("<i class='loadingIcon fa fa-spin fa-circle-o-notch'></i>");
            }

            // Re-select in case DOM changed
            let feedbackList = $("#feedbackContainer .feedback-list").eq(1);

            if (!feedbackList.length || feedbackList.children().length === 0)
            {
                feedbackList = $("#feedbackContainer .feedback-list").filter(function()
                {
                    return $(this).children().length > 0;
                }).first();
            }

            if (feedbackList.length && feedbackList[0] instanceof Node)
            {
                const observer = new MutationObserver((mutationsList, observer) =>
                {
                    for (const mutation of mutationsList)
                    {
                        if (mutation.addedNodes.length)
                        {
                            feedbackLoadMoreBtn.find(".loadingIcon").remove();
                            cleanFeedbackQuestionMarks();
                            observer.disconnect();
                            break;
                        }
                    }
                });

                const config = { childList: true, subtree: true };

                observer.observe(feedbackList[0], config);
            }
        });


        // scroll to top button mobile
        const scrollToTopBtn = document.getElementById("scroll-to-top-btn");

        window.addEventListener("scroll", function()
        {
            if (window.scrollY > 500)
            {
                scrollToTopBtn.classList.add("show");
            }
            else
            {
                scrollToTopBtn.classList.remove("show");
            }
        });

        scrollToTopBtn.addEventListener("click", function()
        {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });

        // Tooltips für Kassenbutton im Warenkorb, Bewerbungsbutton und FL-Filter Range-Slider deaktivieren
        $(".btn.btn-appearance.btn-lg.btn-block.text-truncate").on("mouseenter", function()
        {
            $(this).tooltip("disable");
        });

        $(".fl-range-slider-submit-btn-container button").on("mouseenter", function()
        {
            $(this).tooltip("disable");
        });

        $(".widget.widget-link.widget-primary.text-center.text-md-left a.btn.btn-appearance.btn-lg.mt-3.ml-0.pt-3.pr-5.pb-3.pl-5").on("mouseenter", function()
        {
            $(this).tooltip("disable");
        });

        const offset = 250;
        const duration = 300;

        let isDesktop = window.matchMedia("(min-width: 768px)").matches;

        AutoFocusService.autoFocus();

        $("#searchBox").on("shown.bs.collapse", function()
        {
            const searchInput = document.querySelector("input.search-input");

            if (searchInput)
            {
                searchInput.focus();
            }
        });

        // FAQ Accordion Scrolling

        if (window.matchMedia("(max-width: 576px)").matches)
        {
            $("[id^=heading_]").on("click", function()
            {
                let $this = $(this);

                setTimeout(function()
                {
                    // Scroll to the top of the clicked question
                    $("html, body").animate({
                        scrollTop: $this.offset().top
                    }, 200);
                }, 500);
            });
        }


        // function setCookie()
        // {
        //     // eslint-disable-next-line line-comment-position
        //     const date = new Date(); // Get today's date
        //
        //     date.setTime(date.getTime() + (90*24*60*60*1000));
        //     const expires = "expires="+date.toUTCString();
        //
        //     document.cookie = "cookieAccept" + "=" + true + ";" + expires + ";path=/";
        // }

        // const minLength = 4;
        // const maxLength = 4;
        //
        // $(".postalCodeCustom").focusout(function()
        // {
        //     const value = $(this).val();
        //
        //     console.log("focusout");
        //     if (value.length < minLength)
        //     {
        //         $("#errTxtZipLength").show();
        //     }
        //     else if (value.length > maxLength)
        //     {
        //         $("#errTxtZipLength").show();
        //     }
        //     else
        //     {
        //         $("#errTxtZipLength").hide();
        //     }
        // });


        // $("#cookiebanner-button-id").click(function()
        // {
        //     setCookie();
        //     $("#cookiebanner-id").attr("style", "display: none !important");
        // });
        //
        // const cookieAccept = getCookie("cookieAccept");
        //
        // if (cookieAccept)
        // {
        //     $("#cookiebanner-id").attr("style", "display: none !important");
        // }
        // else
        // {
        //     $("#cookiebanner-id").attr("style", "display: block !important");
        // }

        $( ".single-item-feedback-average" ).on( "click", function()
        {
            $("html, body").animate({ scrollTop: $("#feedbackContainer").offset().top -20 }, "slow");
        } );

        window.addEventListener("scroll", function()
        {
            if (isDesktop)
            {
                if ($(window).scrollTop() > offset)
                {
                    $(".back-to-top").fadeIn(duration);
                    $(".back-to-top-center").fadeIn(duration);
                }
                else
                {
                    $(".back-to-top").fadeOut(duration);
                    $(".back-to-top-center").fadeOut(duration);
                }
            }
        }, detectPassiveEvents() ? { passive: true } : false );

        window.addEventListener("resize", function()
        {
            isDesktop = window.matchMedia("(min-width: 768px)").matches;
        });

        $(".back-to-top").click(function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $(".back-to-top-center").click(function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $("#accountMenuList").click(function()
        {
            $("#countrySettings").collapse("hide");
            $("#searchBox").collapse("hide");
            $("#currencySelect").collapse("hide");
        });

        fixPopperZIndexes();

        // Emit event for Sticky Containers to update
        $(".collapse").on("show.bs.collapse hide.bs.collapse", function()
        {
            this.dispatchEvent(new CustomEvent("updateStickyContainer",
                {
                    bubbles: true
                }));
        });
    });
}

window.CeresMain = new CeresMain();
window.CeresNotification = NotificationService;
window.CeresUrlService = UrlService;

const showShopNotification = function(event)
{
    if (event.detail.type)
    {
        switch (event.detail.type)
        {
        case "info":
            NotificationService.info(event.detail.message);
            break;
        case "log":
            NotificationService.log(event.detail.message);
            break;
        case "error":
            NotificationService.error(event.detail.message);
            break;
        case "success":
            NotificationService.success(event.detail.message);
            break;
        case "warning":
            NotificationService.warn(event.detail.message);
            break;
        default:
            console.log("no type such as:" + event.detail.type);
            break;
        }
    }
};

document.addEventListener("showShopNotification", showShopNotification);

// fixate the header elements
// new HeaderScroller();

$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
    const parent = widgetElement[1];

    const parentComponent = getContainingComponent(parent);

    const compiled = Vue.compile(widgetElement[0].outerHTML, { delimiters: ["${", "}"] } );
    const component = new Vue({
        store: window.ceresStore,
        render: compiled.render,
        staticRenderFns: compiled.staticRenderFns,
        parent: parentComponent
    });

    component.$mount( widgetElement[0] );
    $(component.$el).find("*").each(function(index, elem)
    {
        $(elem).click(function(event)
        {
            event.preventDefault();
        });
    });

    $(component.$el).find(".owl-carousel").on("resized.owl.carousel", function()
    {
        window.dispatchEvent(new Event("resize"));
    });
});

function fixPopperZIndexes()
{
    const elements = document.querySelectorAll(".popover.d-none");

    let counter = elements.length;

    elements.forEach(el =>
    {
        let zIndex = parseInt(getStyle(el, "z-index"));

        if (!isNaN(zIndex))
        {
            zIndex += --counter;

            el.style.zIndex = zIndex;
        }
    });
}
